{
  "password-form": {
    "text": {
      "password": "Passwort",
      "password-confirmation": "Bestätigung des Passworts"
    }
  }
}
